import { IconButton } from '@mui/material';
import { CSSProperties } from 'react';
import { FaEnvelope } from 'react-icons/fa6';
import { Link, useNavigate } from 'react-router-dom';
import { useCommonAppContext } from '~/shared/contexts/CommonAppContext';
import MenuToggle from '~/shared/layouts/MenuToggle';
import { getLcn } from '~/utils/labeled-classnames';
import { useIsAtOrNarrowerThan } from '~/shared/utils/useBreakpoint';
import { publicStorageUrl } from '~/utils/paths';
export const logoUrl = publicStorageUrl('coaching/images/logos/sm/logo_1.webp');

const ContactButton = () => {
  const navigate = useNavigate();

  return (
    <IconButton
      onClick={() => { navigate('/pages/contact') }}>
      <FaEnvelope />
    </IconButton>
  )
}

const Banner = () => {
  const isXs = useIsAtOrNarrowerThan('xs');
  const navigate = useNavigate();

  const styles: { [key: string]: CSSProperties } = {
    bannerComponent: {
    },
    signOut: {
      position: 'relative',
      zIndex: '11',
    },
    brandText: {
      position: 'relative',
      zIndex: '10',
      color: '#093b6b'
    },
  }

  const lcn = getLcn({
    xsBannerTop: 'flex justify-between items-center bg-[#f5f4f4] px-2',
    bannerComponent: [
      'flex flex-col bg-white',
      'relative ',
      'mb-4 sm:mb-2 '
    ],
    wideLine: [
      'flex items-center justify-between sm:p-2 bg-scene',
      'relative '
    ],
    branding: [
      'flex flex-col gap-1 items-center w-full',
    ],
    logoBar: [
      'flex gap-1 sm:gap-4 brand-font text-3xl transition-all  sm:text-4xl text-center',
      'items-end'
    ],
    logo: 'h-auto w-[60px] sm:w-[70px] transition-all ',
    for: 'brand-font text-xl sm:text-2xl text-[#c78b2d]',
  });

  const { sessionUser } = useCommonAppContext()

  return (
    <div id='banner-component' className={lcn.bannerComponent} style={styles.bannerComponent}>
      {isXs &&
        <div className={lcn.xsBannerTop}>
          <div>
            <MenuToggle />
          </div>
          <div>
            <ContactButton />
          </div>
        </div>
      }

      <div className={lcn.wideLine} >
        {!isXs &&
          <div>
            <MenuToggle />
          </div>
        }

        <div className={lcn.branding}>
          <Link to="/" className={lcn.logoBar} style={styles.brandText}>
            <div>
              Ben Lieb
            </div>
            <div>
              <img className={lcn.logo} style={styles.logo} src={logoUrl} />
            </div>
            <div>
              Coaching
            </div>
          </Link>

          <div className={lcn.for}>
            for Aspiring Humans
          </div>
        </div >

        {!isXs &&
          <div>
            <ContactButton />
          </div>
        }
      </div >
    </div >

  )
}

export default Banner;